import { defineStore } from "pinia";
import StorageHelper from "@/utils/storageHelper";

export const useAnalysisStore = defineStore("analysis", {
  state: () => ({
    source: "",
    productID: 0,
    platform: "",
    src1: "",
    src2: "",
    src3: "",
    src4: "",
    // 首屏完整 query 快照（原始 search 字符串），用于页面重载后还原地址参数（如小程序支付返回时 H5 重载）
    entryQueryString: "",
  }),

  getters: {
    getSource: (state) => state.source,
    getProductID: (state) => state.productID,
    getPlatform: (state) => state.platform,
    getEntryQueryString: (state) => state.entryQueryString,
  },

  actions: {
    setSource(source) {
      this.source = source;
    },
    setProductID(productID) {
      this.productID = productID;
      StorageHelper.set("productID", productID);
    },
    setPlatform(platform) {
      this.platform = platform;
      StorageHelper.set("platform", platform);
    },
    setSrcParams(src1: string | null, src2: string | null, src3: string | null, src4: string | null) {
      this.src1 = src1 || "";
      this.src2 = src2 || "";
      this.src3 = src3 || "";
      this.src4 = src4 || "";
    },
    setEntryQueryString(queryString: string) {
      this.entryQueryString = queryString || "";
    },
  },
});
